import makeCrudModule from '@/factories/CrudModelFactory';
import rolesService from '@/services/roles';

export default makeCrudModule({
    service: rolesService,
    dateConvert: [
        'created_at', 'updated_at'
    ]
});
